import TagManager from "react-gtm-module";

interface InitializeGTMParams {
  loginId: string;
  storeId: string;
  storeName: string;
  enterpriseId: string;
  enterpriseName: string;
}

export const initializeGoogleTagManager = ({
  loginId,
  storeId,
  storeName,
  enterpriseId,
  enterpriseName,
}: InitializeGTMParams): void => {
  TagManager.initialize({
    gtmId: "GTM-P8QBWVM",
    dataLayer: {
      event: "C-pageview",
      userId: loginId,
      internalUser: "true",
      storeId,
      storeName,
      enterpriseId,
      enterpriseName,
    },
  });
};